import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { TRACK_EVENTS } from 'app-webtech-core/modules/playbackSession/actions/types';
import { clipStarts, episodeStarts } from 'app-webtech-core/modules/player/actions';
import { PLAY, CLICK_PLAY } from './types';
import { playerEndBufferingAction } from './endBuffering';
import { playerIsBufferingSelector } from '../selectors/isBuffering';
import { load } from '../../playbackSession/actions';

export const playerPlayAction = actionCreator(PLAY);
export const clickPlay = actionCreator(CLICK_PLAY);
const startTrackingAction = actionCreator(TRACK_EVENTS);

export const clickPlayAction = ({ doNotTrack = false }) => (dispatch, getState) => {
  if (!doNotTrack) {
    const state = getState();
    dispatch(clickPlay());
    if (state.player.isPaused) {
      dispatch(startTrackingAction({ trackClipEvents: true }));
      dispatch(startTrackingAction({ trackChannelEvents: true }));
      dispatch(episodeStarts());
      dispatch(clipStarts());
    }
  }
};

export const playerPlayThunkAction = () => async (dispatch, getState) => {
  const state = getState();
  if (playerIsBufferingSelector(state)) {
    await dispatch(playerEndBufferingAction({ timestamp: Date.now() }));
  }
  dispatch(load());
  return dispatch(playerPlayAction());
};
